import React from "react";

import HoverTextOverlay from "core/HoverTextOverlay";
import ImagesContainerGridView from "./ImagesContainerGridView";

import { IndividualImageBox, Image } from "./styles";

import { usePhotoUploadPreviewData } from "../../PhotoUploadCore/hooks";

const ImagesContainer = ({ uploads }) => {
    const { getUploadPreview } = usePhotoUploadPreviewData();

    if (!uploads || !uploads.length) return null;

    const isGridVersion = uploads.length > 1;

    if (!isGridVersion) {
        const { id, photoTitle, originalFilename } = uploads[0];
        const uploadPreview = getUploadPreview(id);
        const uploadName = photoTitle || originalFilename;

        if (!uploadPreview) return null;

        return (
            <IndividualImageBox>
                <Image
                    src={uploadPreview.preview}
                    alt={`File name ${uploadName}`}
                />

                <HoverTextOverlay hoverText={uploadName} />
            </IndividualImageBox>
        );
    } else {
        return <ImagesContainerGridView uploads={uploads} />;
    }
};

export default ImagesContainer;
